import { render, staticRenderFns } from "./FactorUse.vue?vue&type=template&id=6718508f"
import script from "./FactorUse.vue?vue&type=script&lang=ts"
export * from "./FactorUse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports